import script from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePassword.vue?vue&type=script&setup=true&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=d757343a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d757343a"]])

export default __exports__